import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { PdfRetrieveInterface } from "../../../middleware/interfaces/file/pdf-retrieve-interface";

export const PdfRetrieve = {
  Retrieve: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const pdfRetrieve: PdfRetrieveInterface = state.data;
      const url = "./php/file/pdf-retriever-proxy.php";
      await axios
        // Only what the retriever needs. Identity comes from the session, and
        // the version picks which stored copy of the file is opened.
        .post(url, {
          projectID: pdfRetrieve.projectID,
          fileID: pdfRetrieve.fileID,
          fileActiveVersion: pdfRetrieve.fileActiveVersion,
        })
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = {
        status: "error",
        header: "error",
        message: "Something went wrong! Please contact DigitalCharcoal",
      };
    }

    return serverResponse;
  },
};
